import React, { useState, useContext } from "react";

import { MetaMaskContext } from '../context/mm-context'
import Button from "./shared/Button";

function PreSaleDapp(props) {

    // extract the contract data from the props
    const { data } = props;

    // retrieve site context
    const ctx = useContext(MetaMaskContext);

    // set some state
    const [feedback, setFeedback] = useState();
    const [mintAmount, setMintAmount] = useState(1);
    const [claimNft, setClaimNft] = useState(false);

    // mint an NFT
    const mintToken = async () => {
        setFeedback(<>DO NOT REFRESH THE PAGE<br />Please wait while we perform some checks and process the transaction</>);
        setClaimNft(true);

        let cost = data.preSaleCost;
        let gasLimit = 285000;
        let totalCostWei = String(cost * mintAmount);
        let totalGasLimit = String(gasLimit * mintAmount);

        try {

            const isPreSaleActive = await ctx.ethContract.isPreSaleActive()
            if (!isPreSaleActive) {
                props.getContractData(false)
                throw { code: 99999, message: `Presale is not active` }
            };

            const remaining = await ctx.ethContract.getRemainingPublicSupply()
            if (parseInt(remaining) <= 0) throw { code: 99999, message: `All NFTs have been sold` };

            const isWhitelisted = await ctx.ethContract.isWhitelisted(data.proof, ctx.ethAddress)
            if (!isWhitelisted) throw { code: 99999, message: `According to our records you are not whitelisted` };

            const maxPreSalePerWallet = await ctx.ethContract.maxPreSalePerWallet()
            if (mintAmount > parseInt(maxPreSalePerWallet)) throw { code: 99999, message: `Only ${maxPreSalePerWallet} NFTs allowed per whitelisted wallet address` };

            const minters = await ctx.ethContract.minters(ctx.ethAddress);
            if (mintAmount + parseInt(minters.hasMintedByWhitelist) > parseInt(maxPreSalePerWallet)) throw { code: 99999, message: `Only ${maxPreSalePerWallet} NFTs allowed per whitelisted wallet address` };

            const tx = await ctx.ethContract.mintPreSale(mintAmount, data.proof, { gasLimit: String(totalGasLimit), from: ctx.ethAddress, value: totalCostWei });
            const rc = await tx.wait();

            props.getContractData(false)

            setFeedback(<>You have minted your very own {data.name} NFT on the <a target="_blank" rel="noreferrer" href={ctx.network.etherScan + "tx/" + rc.transactionHash}>Ethereum Blockchain</a>. Head over to <a target="_blank" rel="noreferrer" href={ctx.network.openSea + ctx.ethAddress}>OpenSea</a> to check it out</>)

            setClaimNft(false);

        } catch (err) {

            let message = '';
            if (err.code === 99999) {
                message += err.message;
            } else if (err.code === 4001) {
                message += 'Transaction cancelled';
            } else {
                message += 'Something went wrong.';
            }
            setFeedback(
                <>
                    <span className="text-warning fw-bold">{message}</span>
                    {err.code !== 99999 && err.code !== 4001 && 
                    <>
                        <br />
                        <span className="text-warning">
                            Please check
                            {" "}
                            <u><a target="_blank" rel="noreferrer" href={ctx.network.etherScan + "address/" + ctx.ethAddress}>etherscan.io</a></u>
                            {" "}
                            before attempting to mint again to ensure you do not have a pending transaction.
                        </span>
                    </>}
                </>
            );
            setClaimNft(false);
        }
    }

    // lower the amount to mint
    const decrementMintAmount = (e) => {
        e.preventDefault();
        let newMintAmount = mintAmount - 1;
        if (newMintAmount < 1) {
            newMintAmount = 1;
        }
        setMintAmount(newMintAmount);
    };

    // increase the amount to mint
    const incrementMintAmount = (e) => {
        e.preventDefault();
        let newMintAmount = mintAmount + 1;
        if (newMintAmount > data.maxPreSalePerWallet) {
            newMintAmount = data.maxPreSalePerWallet;
        }
        setMintAmount(newMintAmount);
    };

    return (
        <>
            <div className="text-tota bg-tota-blur mb-2 rounded mx-auto p-3 noselect" style={{ maxWidth: "350px" }}>

                <div className="mx-auto display-4 fw-bold smallcaps mb-4">Presale</div>

                <div className="d-flex justify-content-center align-items-center mb-3">
                    <div className="input-group mb-1" style={{ width: "175px" }}>
                        <span className="input-group-text fs-4 cursor-pointer bg-tota-dark border-tota-dark text-tota change-amount" onClick={(e) => { decrementMintAmount(e) }}>
                            <i className="bi bi-dash" style={{ marginBottom: "-4px" }}></i>
                        </span>
                        <input type="text" className="form-control text-center p-0 noselect border-0 bg-none input-disabled-tota" style={{ fontSize: "40px" }} disabled value={mintAmount} />
                        <span className="input-group-text fs-4 cursor-pointer bg-tota-dark border-tota-dark text-tota change-amount" onClick={(e) => { incrementMintAmount(e) }}>
                            <i className="bi bi-plus" style={{ marginBottom: "-4px" }}></i>
                        </span>
                    </div>
                </div>

                {data && <div className="fs-6 fw-bold mx-auto my-4" style={{ maxWidth: "300px", letterSpacing: "1px" }}>each NFT costs {data.preSaleCostEth} ETH <br /> <span className="small smallcaps">( plus gas )</span></div>}

                <Button
                    content={!claimNft && "MINT" || "MINTING..."}
                    colour={!claimNft && "btn-tota-dark" || "btn-tota-dark"}
                    onClick={mintToken}
                    disabled={claimNft && 'disabled'}
                    style={{ width: "250px" }}
                    size={"btn-lg"}
                    styles={"mx-auto " + (claimNft ? "cursor-wait" : "")}
                />
            </div>

            {(feedback || data) &&
                <div className={`text-tota bg-tota-blur mt-3 mx-auto p-2`} role="alert" style={{ maxWidth: "350px" }}>
                    {feedback ?
                        <>{feedback}</> :
                        data.isWhitelisted ?
                            <>Your Ethereum wallet address is whitelisted for the presale. please note that a maximum of {data.maxPreSalePerWallet} NFTs per wallet address can be minted</> :
                            <>Please ensure that you only attempt to mint if your Ethereum wallet address been added to the whitelist / allow list</>}
                </div>
            }

            <div className="text-tota bg-tota-blur small rounded text-center mt-5 mb-2 p-2 mx-auto" role="alert" style={{ maxWidth: "500px" }}>
                <p className="fw-bold">Please Read</p>
                <p>Once you make the purchase, it can't be reversed or cancelled</p>
                <p>We have set the gas limit to 285000 GWEI for the contract to successfully mint your NFT. We recommend that you don't lower the gas limit</p>
            </div>
        </>
    );
}

export default PreSaleDapp;
